import FieldbookPesticides from './FieldbookPesticides'

export default FieldbookPesticides
